export default "__VITE_ASSET__BrSdB38R__"